import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { IRiskCalculatorPayload } from 'src/app/models/facility';
import { MapService } from 'src/app/core/services/map.service';

@Component({
  selector: 'app-risk-calculator',
  templateUrl: './risk-calculator.component.html',
  styleUrls: ['./risk-calculator.component.css']
})
export class RiskCalculatorComponent implements OnInit, OnChanges {

  @Input() facilityId: number;
  @Output() riskLevel = new EventEmitter<number>();
  riskCalulationResult: IRiskCalculatorPayload;

  constructor(private mapService: MapService) { }
  riskStatus: string;

  ngOnInit(): void {
    this.getRiskCalculation();
  }
  ngOnChanges() {
    this.getRiskCalculation();
  }
  getRiskCalculation() {
    this.mapService.getRiskCalculation(this.facilityId).subscribe(response => {
      if (response.message === undefined) {
        this.riskCalulationResult = response.payload;
        if (this.riskCalulationResult.riskLevel === 1) {
          this.riskStatus = 'risk-status low';
        } else if (this.riskCalulationResult.riskLevel === 2) {
          this.riskStatus = 'risk-status medium';
        } else if (this.riskCalulationResult.riskLevel === 3) {
          this.riskStatus = 'risk-status high';
        } else if (this.riskCalulationResult.riskLevel === 4) {
          this.riskStatus = 'risk-status notavailable';
        }
        this.riskLevel.emit(this.riskCalulationResult.riskLevel);
      }
    });
  }

}
